/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react'
import styled from 'styled-components'
import { graphql, useStaticQuery } from 'gatsby'

// Elements
import ParseContent from 'components/shared/ParseContent'
import Plaatjie from '@ubo/plaatjie'

// Interface
import { TextProps } from 'components/flex/Text/TextShell'
import { PostContext } from 'templates/post'

const SOCIALS_PAGE_ID = 3293

const Content = styled(ParseContent)`
  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    margin-bottom: 2rem;
    & > strong {
      font-weight: ${({ theme }) => theme.font.weight.extraBold};
    }
  }

  & a {
    color: ${({ theme }) => theme.color.dark};
    font-weight: bold;

    &:hover {
      color: ${({ theme }) => theme.color.secondary};
    }
  }
`

const SocialIcon = styled(Plaatjie)`
  width: 32px;
  height: 32px;

  filter: brightness(0) saturate(100%) invert(14%) sepia(21%) saturate(1817%)
    hue-rotate(186deg) brightness(95%) contrast(93%);
  transition: opacity 0.2s ease;
`

const Socials = styled.div`
  & a {
    font-size: 0;
    opacity: 0.85;

    &:hover {
      opacity: 1;
    }
  }
`

const VideoWrapper = styled.div`
  & iframe {
    width: 100%;
    border: 0;
    aspect-ratio: 16 / 9;
  }
`

const TextVideo: React.FC<TextProps> = ({ fields }) => {
  const { databaseId } = useContext(PostContext)

  const { fields: footerFields } = useStaticQuery<GatsbyTypes.textSocialsQueryQuery>(
    graphql`
      query textSocialsQuery {
        fields: wpComponent(databaseId: { eq: 98 }) {
          footer {
            menuFooterLeft {
              socials {
                icon {
                  altText
                  localFile {
                    publicURL
                  }
                }
                link {
                  title
                  url
                }
              }
            }
          }
        }
      }
    `
  )

  const socials = footerFields?.footer?.menuFooterLeft?.socials
  const showSocials = Number(databaseId) === SOCIALS_PAGE_ID

  if (!fields.description && !fields.video) {
    return null
  }

  return (
    <section className="mb-5 pb-lg-3">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row">
              {fields.description && (
                <div className="col-lg-8 mb-4 mb-lg-0">
                  <Content content={fields.description} />
                  {showSocials && socials && (
                    <Socials className="d-flex align-items-center my-4">
                      {socials.map((s: any, index: number) => (
                        <a
                          key={index}
                          href={s.link.url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {s.link.title}
                          <SocialIcon
                            image={s.icon}
                            className="me-3"
                            alt={s.icon.altText}
                          />
                        </a>
                      ))}
                    </Socials>
                  )}
                </div>
              )}
              {fields.video && (
                <div className="col-lg-4">
                  <VideoWrapper>
                    <Content content={fields.video} />
                  </VideoWrapper>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TextVideo
